import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026DatosGenerales() {
  return <CategoryPage category="anexo21Y22Rmf2026DatosGenerales" pageTitle="Datos Generales 2026" />;
}

export default Anexo21Y22RMF2026DatosGenerales;
